import { NetbankingAPI } from "aaa";
import { NetbankingAPIClient } from "network/APIClient";
import { pushRoute } from "stores/RouterFunctions";
import { parse } from "query-string";
import { safeWindowOpen } from "./helpers";


export const performStoreHandoverTokenExchange = async (url: string) => {
    const query = parse(url.split("?")[1]);
    if (!query.channel) {
        // no channel -> cannot determine token exchange clientId
        pushRoute("/error");
        return;
    }

    // Info from teams call on 2024-05-08
    let clientId = "";
    if (query.channel === "09") {
        clientId = "INT82482";  // ClientID Store Web
    } else if (query.channel === "10") {
        clientId = "INT824BB";  // ClientID Store App
    } else {
        // unknown channel
        pushRoute("/error");
        return;
    }

    try {
        const target = NetbankingAPI.tokenExchange(clientId);
        const res = await NetbankingAPIClient.requestType(target);
        const accessToken = res.access_token;
        const handoverUrl = `${url}#access_token=${accessToken}`;
        safeWindowOpen(handoverUrl);
    } catch (error) {
        pushRoute("/error");
    }
};




// WEBPACK FOOTER //
// ./src/util/storeHandover.ts